<!--
 * @Author: your name
 * @Date: 2021-05-07 10:37:50
 * @LastEditTime: 2021-05-07 11:08:12
 * @LastEditors: Please set LastEditors
 * @Description: 处方药品
 * @FilePath: /dsicm-admin-web/src/views/treatment/components/messageTypeCompnents/custom-five.vue
-->


<template>
  <div class="custom-5" :style="{backgroundColor: bgColor,color: color}">
    <div class="info-content">
        <div class="info-head">Rp:</div>
        <div class="info-init-title">初步诊断：<span class="info-init">{{data.initDiagnosis}}</span></div>
        <div class="info-drug" v-for="(item,index) in data.itemList" :key="index">
            <div class="info-drug-name">
                <div class="info-drug-title">{{item.drugName}}</div>
                <div class="info-drug-text">*{{item.drugNumber}}</div>
            </div>
            <div class="info-drug-text">{{item.drugSpecification}}</div>
      </div>
      <div class="info-btn">查看处方</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    data:{
      type: Object,
      default: ()=>{}
    },
     bgColor:{
      type: String,
      default: '#F5F5F5'
    },
    color:{
      type: String,
      default: '#333'
    }
  },
  data(){
    //   "{"handleOpinion":"",
    //   "initDiagnosis":"test",
    //   "itemList":
    //     [{"drugName":"硝苯地平缓释片",
    //         "drugNumber":"3",
    //         "drugSpecification":"10mg*60s薄膜衣"
    //         }],
    //     "id":"1380412294832787458"}"
  }
}
</script>

<style scoped lang="less">
.custom-5{
min-width: 300px;
border-radius: 4px;
.info-content {
        padding:15px 20px;
        color: #333;
        .info-head{
            font-size: 15px;
            font-weight: 500;
        }
        .info-init-title{
            font-size: 12px; 
            margin: 10px 0;
            .info-init{
                font-size: 15px;
                font-weight: 500;
            }           
        }
        .info-drug{
            margin-bottom: 11px;
            
            .info-drug-name{
                display: flex;
                justify-content: space-between;
                
                .info-drug-title{
                    font-size: 13px;
                    color: #333;
                    font-weight: 500;
                }
                .info-drug-text{
                    font-size: 12px;
                    color:#999;
                }
                
            }
            .info-drug-text{
                    font-size: 12px;
                    color:#999;
                }
        }
        .info-btn{
            width: 84px;
            padding: 7px 0;
            text-align: center;
            border-radius: 20px;
            background: linear-gradient(224deg, #23C1C0 0%, #47EDB7 100%);
            color:#fff;
        }

    }
}
</style>